import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=a0b4656c&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=ts&setup=true"
export * from "./Catalog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=a0b4656c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b4656c",
  null
  
)

export default component.exports